import { useLookupIP } from "@outschool/iplookup-client";

/**
 * Check if the learner consent settings should be displayed. We only show them
 * for users in the US states of Washington and Nevada.
 */
export function useLearnerConsent(): {
  isEnabled: boolean;
  isLoading: boolean;
} {
  const { isInWaNv, ipInfoLoaded } = useLookupIP();

  return {
    isEnabled: isInWaNv,
    isLoading: !ipInfoLoaded,
  };
}
